import React from 'react'
import Navbar from '../components/Navbar';
import { useMoralis } from "react-moralis";
import {Redirect } from 'react-router-dom';

import DashboardView from '../components/DashboardView'

function Dashboard() {

    const { authenticate, isAuthenticated, user } = useMoralis();

    if(!isAuthenticated){
        return <Redirect to="/login"/>;
    }

    return (
        <div>
            <Navbar/>
            <DashboardView/>
            
        </div>
    )
}

export default Dashboard
